import { useState } from "react";
import DataTable from "../DataTable";
import PageContent from "../PageContent";
import TableContainer from "../TableContainer";
import DataMaskInput from "../masks/DataMaskInput";
import { formatQuantidade } from "../../../service/utils/formatQuantidade";

function ConfirmarEntregaModal({ show, onClose, onConfirm, onConfirmTotal, entityType, entityId, usuario, itens, onItemChange, numNotaFiscal, serieNotaFiscal, dataNotaFiscal, valorNotaFiscal, onNfChange }) {
  if (!show) return null;

  const [isLoading, setLoading] = useState(true);
  const semSaldo = itens.every(item => (item.qtdeEntregueAnt || 0) >= (item.qtdePedida || 0));
  const temItemPreenchido = itens.some(item => item.qtdeEntregueNova > 0);
  const nfPreenchida = numNotaFiscal && numNotaFiscal.trim() !== '';
  const valorEntrega = itens.reduce((sum, item) => sum + (item.qtdeEntregueNova || 0) * (item.valorUnit || 0), 0);
  const valorNfNum = parseFloat(String(valorNotaFiscal || '0').replace(/\./g, '').replace(',', '.'));
  const nfDivergente = nfPreenchida && valorNfNum > 0 && Math.abs(valorNfNum - valorEntrega) > 0.01;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)'}}>
      <div className="modal-dialog modal-lg" style={{ maxWidth: '95vw', height: '90vh' }}>
          <div className="modal-content h-100 overflow-hidden">
          <div className="modal-header text-white" 
          style={{
              background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
              padding: '0.5rem 1rem',
              borderTopLeftRadius: '0.5rem',
              borderTopRightRadius: '0.5rem',
              border: 'none',
            }}>
            <h5 className="modal-title">
              <i className="bi bi-check2-circle me-2" />
              Confirmar Entrega — {entityType} #{entityId}
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <PageContent>
            <div className="row small bg-light rounded py-2">
              <div className="col-6">
                <span className="text-muted">{entityType} por: </span>
                <strong>{usuario || '—'}</strong>
              </div>
              <div className="col-6">
                <span className="text-muted">Confirmação por: </span>
                <strong>{localStorage.getItem('login') || '—'}</strong>
              </div>
            </div>
             <TableContainer>
              <DataTable style={{ fontSize: '0.8rem' }} head={
                <tr>
                  <th className="text-center align-middle">Descrição</th>
                  <th className="text-center align-middle">Qtde Pedida</th>
                  <th className="text-center align-middle">Já Entregue</th>
                  <th className="text-center align-middle" style={{ width: 110 }}>Entregue Agora</th>
                  <th className="text-center align-middle">Saldo Pendente</th>
                  <th className="text-center align-middle">Valor Unit.</th>
                  <th className="text-center align-middle text-nowrap">Valor Pedido</th>
                  <th className="text-center align-middle text-nowrap">Valor já Entregue</th>
                  <th className="text-center align-middle text-nowrap">Valor Entregue Agora</th>
                  <th className="text-center align-middle text-nowrap">Valor Pendente</th>
                </tr>}>
              
              <tbody>
                {itens.map((item, idx) => {
                  const saldo = item.qtdePedida - item.qtdeEntregueAnt - item.qtdeEntregueNova;
                  const fmt = v => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
                  return (
                    <tr key={item.idArpItem || item.idContratoItem || idx}>
                      <td>{item.descricao} {item.unidade ? `(${item.unidade})` : ''}</td>
                      <td className="text-center">{formatQuantidade(item.qtdePedida)}</td>
                      <td className="text-center">{formatQuantidade(item.qtdeEntregueAnt)}</td>
                      <td className="text-center">
                        <input
                          type="number"
                          className="form-control form-control-sm text-center"
                          min={0}
                          step="0.01"
                          max={item.qtdePedida - item.qtdeEntregueAnt}
                          value={item.qtdeEntregueNova}
                          disabled={semSaldo}
                          onChange={e => {
                            const val = Math.min(
                              Math.max(0, parseFloat(e.target.value) || 0),
                              item.qtdePedida - item.qtdeEntregueAnt
                            );
                            if (!semSaldo) onItemChange(idx, val);
                          }}
                        />
                      </td>
                      <td className={`text-center fw-bold ${saldo === 0 ? 'text-success' : saldo < 0 ? 'text-danger' : 'text-primary'}`}>
                        {formatQuantidade(saldo)}
                      </td>
                      <td className="text-center small">{fmt(item.valorUnit)}</td>
                      <td className="text-center">{fmt(item.qtdePedida * item.valorUnit)}</td>
                      <td className="text-center text-success">{fmt(item.qtdeEntregueAnt * item.valorUnit)}</td>
                      <td className="text-center text-info">{fmt(item.qtdeEntregueNova * item.valorUnit)}</td>
                      <td className="text-center fw-bold text-primary">{fmt(saldo * item.valorUnit)}</td>
                    </tr>
                  );
                })}
              </tbody>
              </DataTable>
            </TableContainer>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <div className="mb-2">
                  <label className="form-label small fw-semibold">Nº Nota Fiscal</label>
                  <input type="text" className="form-control form-control-sm" name="numNotaFiscal" value={numNotaFiscal} onChange={e => onNfChange && onNfChange({ name: e.target.name, value: e.target.value })} maxLength={20} placeholder="NF" disabled={semSaldo} />
                </div>
              </div>
              <div className="col-md-2">
                <div className="mb-2">
                  <label className="form-label small fw-semibold">Série</label>
                  <input type="text" className="form-control form-control-sm" name="serieNotaFiscal" value={serieNotaFiscal} onChange={e => onNfChange && onNfChange({ name: e.target.name, value: e.target.value })} maxLength={10} placeholder="Série" disabled={semSaldo} />
                </div>
              </div>
              <div className="col-md-3">
                <div className="mb-2">
                  <label className="form-label small fw-semibold">Data NF</label>
                  <DataMaskInput name="dataNotaFiscal" value={dataNotaFiscal} onChange={e => onNfChange && onNfChange({ name: e.target.name, value: e.target.value })} disabled={semSaldo} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-2">
                  <label className="form-label small fw-semibold">Valor NF (R$)</label>
                  <input type="text" className="form-control form-control-sm" name="valorNotaFiscal" value={valorNotaFiscal} onChange={e => onNfChange && onNfChange({ name: e.target.name, value: e.target.value })} placeholder="0,00" disabled={semSaldo} />
                </div>
              </div>
            </div>
          </PageContent>
          <div className="modal-footer p-1 d-flex align-items-center gap-1">
            {semSaldo && (
              <div className="alert alert-warning py-1 px-2 mb-1 small flex-grow-1 d-flex text-danger align-items-center">
                <i className="bi bi-info-circle me-1"></i>
                <strong>{entityType} totalmente entregue. Os dados são exibidos apenas para consulta.</strong>
              </div>
            )}
            {nfDivergente && (
              <div className="alert alert-warning py-1 px-2 mb-1 small flex-grow-1 d-flex text-danger align-items-center">
                <i className="bi bi-exclamation-triangle me-1"></i>
                <strong>Valor da NF ({new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorNfNum)}) diferente do valor da entrega ({new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valorEntrega)})</strong>
              </div>
            )}
            <div className="d-flex justify-content-end align-items-center gap-1 ms-auto">
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
              <i className="bi bi-x-lg me-1" />
              Cancelar Entrega
            </button>
            <button type="button" className="btn btn-success btn-sm" onClick={onConfirm} disabled={!temItemPreenchido || semSaldo || !nfPreenchida}>
              <i className="bi bi-check2 me-1" />
              Confirmar Entrega Parcial
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={onConfirmTotal} disabled={semSaldo || !nfPreenchida}>
              <i className="bi bi-check2-all me-1" />
              Confirmar Entrega Total
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmarEntregaModal;
